<template>
  <div class="brandStreet">
    <van-row class="title">
      <van-col span="8"></van-col>
      <van-col span="8" class="logo">
        <img src="@/assets/images/head-con.jpg" alt="" />
      </van-col>
      <van-col span="8"></van-col>
    </van-row>
    <van-row span="24" class="container">
      <van-tabs swipeable>
        <van-tab v-for="(item, index) of cate_list" :key="index" class="list">
          <div slot="title" class="nav">{{ item.cate_name }}</div>
          <div class="content" v-for="(s_item, s_index) of item.brand_list" :key="s_index">
            <van-row style="height: 2em"></van-row>
            <van-row class="brand">
              <van-col class="logo">
                <img :src="s_item.logo" />
              </van-col>
              <van-col class="text">
                <div class="name">{{ s_item.name }}</div>
                <span class="count">{{ s_item.count }}件商品</span>
              </van-col>
              <van-col class="icon">
                <router-link :to="{
                    path: '/goods_list',
                    query: { id: s_item.id, title: s_item.name, type: 2 }
                  }">
                  <van-icon name="arrow" />
                </router-link>
              </van-col>
            </van-row>
            <van-row class="product" v-for="(t_item, t_index) of s_item.product_list" :key="t_index">
              <router-link :to="{ path: '/detail/' + t_item.id }">
                <van-col class="item">
                  <img :src="t_item.image" />
                  <span class="name">{{ t_item.keyword }}</span>
                  <span class="price"><span v-show="t_item.price !== '请先登录'">￥</span>{{ t_item.price }}</span>
                </van-col>
              </router-link>
            </van-row>
          </div>
        </van-tab>
      </van-tabs>
    </van-row>
  </div>
</template>

<script>
  import Vue from "vue";
  import {
    Row,
    Col
  } from "vant";
  import {
    Tab,
    Tabs
  } from "vant";
  import {
    Icon
  } from "vant";
  import {
    getBrandStreet
  } from "@api/store";

  Vue.use(Row)
    .use(Col)
    .use(Tab)
    .use(Tabs)
    .use(Icon);
  export default {
    name: "Street",
    data() {
      return {
        activeName: 0,
        cate_list: []
      };
    },
    methods: {
      getData() {
        var that = this;
        getBrandStreet().then(res => {
          that.cate_list = res.data.cate_list;
        });
      }
    },
    mounted() {
      this.getData();
    }
  };
</script>

<style scoped></style>
